import styled from 'styled-components'

export const StyledMonitorInfo = styled.div`
    color: ${({ theme, active }) => active ? theme.grassyGreen : theme.brownGrey}
`

export const StyledMonitorText = styled.div`
    margin: 16px 0;
    font-size: 14px;
    color: ${({ theme }) => theme.greyishBrown};
    font-weight: ${({ theme }) => theme.fontWeight.regular}

    p {
        margin: 16px 0;
    }
`